import { Fragment } from 'react';
import ExitButton from 'components/button/ExitButton';
import YesNoButton from 'components/button/YesNoButton';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

const ConfirmModal = ({ showModal, setShowModal, setSubmitForm = () => {}, modalData, handleSubmit = () => {} }) => {
	const handleOk = () => {
		setSubmitForm(true);
		handleSubmit();
		setShowModal(false);
	};

	const handleClose = () => {
		setShowModal(false);
	};

	return (
		<Fragment>
			<Dialog
				keepMounted
				maxWidth={'xs'}
				fullWidth={true}
				open={showModal}
				onClose={handleClose}
				aria-labelledby="draggable-dialog-title"
				sx={{
					zIndex: 1600,
					'& .MuiPaper-root': {
						borderRadius: '12px',
						border: '1px solid #E2E8F0',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
						overflow: 'hidden',
					},
					'& .MuiBackdrop-root': {
						backgroundColor: 'rgba(15, 23, 42, 0.45)',
					},
				}}
			>
				<Box>
					<Grid
						container
						alignItems="center"
						justifyContent="space-between"
						wrap="nowrap"
						sx={{
							height: '48px',
							bgcolor: '#F8FAFC',
							borderBottom: '1px solid #E2E8F0',
						}}
					>
						<Grid item sx={{ minWidth: 0, flex: 1 }}>
							<DialogTitle
								sx={{
									color: '#0F172A',
									display: 'flex',
									alignItems: 'center',
									padding: '0 24px',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{modalData?.head ?? ''}
							</DialogTitle>
						</Grid>

						<Grid item sx={{ mr: 3, flexShrink: 0 }}>
							<ExitButton handleClose={handleClose} color="#64748B" />
						</Grid>
					</Grid>

					<DialogContent sx={{ pt: { xs: 5.25, md: 10 }, pb: { xs: 4, md: 7 } }}>
						<Typography variant="h6" align="center">
							{modalData?.label ? modalData?.label : 'Do you want to proceed?'}
						</Typography>
					</DialogContent>

					<DialogActions sx={{ px: 3, pb: 3, display: 'flex', justifyContent: 'center' }}>
						<YesNoButton handleClick={handleOk} bgColor="#00914f" title="Yes" />
						<YesNoButton handleClick={handleClose} bgColor="#B00020" title="No" />
					</DialogActions>
				</Box>
			</Dialog>
		</Fragment>
	);
};

export default ConfirmModal;
